import * as types from '../../actions/actiontypes';
import initialstate from '../initialstate';
import {isApiResponseOk} from '../../util/utils';

export default function scotMetricsReducer(state = initialstate.scotMetrics, action) {
	switch (action.type) {
		case types.GET_SCOT_METRICS:
			return isApiResponseOk(action) ? action.response : state;

		default:
			return state;
	}
}
